"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreInteractiveIcon = _interopRequireDefault(require("@vfuk/core-interactive-icon"));

var _coreBaseProps = require("@vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/IconNav.style"));

var _simpleClickHandler = _interopRequireDefault(require("../../../../../../helpers/simpleClickHandler"));

var _TopNavigationContext = _interopRequireDefault(require("../../../../../../context/TopNavigationContext"));

var _constants = require("../../../../../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable sonarjs/no-identical-functions */
var IconNav = function IconNav(_ref) {
  var _secondaryNav$iconNav;

  var dataSelectorPrefix = _ref.dataSelectorPrefix;

  var _ref2 = (0, _react.useContext)(_TopNavigationContext["default"]),
      secondaryNav = _ref2.secondaryNav,
      interactionHandler = _ref2.interactionHandler,
      appearance = _ref2.appearance,
      topNavigationTheme = _ref2.topNavigationTheme;

  var _topNavigationTheme$a = topNavigationTheme.appearance[appearance].mainBar,
      interactiveIconAppearance = _topNavigationTheme$a.interactiveIconAppearance,
      inverseIcon = _topNavigationTheme$a.inverseIcon;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, secondaryNav === null || secondaryNav === void 0 ? void 0 : (_secondaryNav$iconNav = secondaryNav.iconNavLinks) === null || _secondaryNav$iconNav === void 0 ? void 0 : _secondaryNav$iconNav.map(function (iconLink) {
    return /*#__PURE__*/_react["default"].createElement(Styled.IconLinkWrapper, {
      key: iconLink.id
    }, /*#__PURE__*/_react["default"].createElement(_coreInteractiveIcon["default"], {
      appearance: interactiveIconAppearance,
      inverse: inverseIcon,
      srText: iconLink.text,
      name: iconLink.icon,
      onClick: function onClick(event) {
        (0, _simpleClickHandler["default"])(event, interactionHandler, dataSelectorPrefix, iconLink);
      },
      href: iconLink.href,
      customRouterProps: iconLink.customRouterProps,
      numberBadge: iconLink.numberBadge ? {
        number: iconLink.numberBadge,
        appearance: 'primary'
      } : undefined,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "".concat(_constants.DataKeys.IconNav, "-").concat(iconLink.id)),
      dataAttributes: iconLink.dataAttributes
    }));
  }));
};

var _default = IconNav;
exports["default"] = _default;
//# sourceMappingURL=IconNav.js.map